var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinivan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 27,
    viewBox: "0 0 68 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.329455 17.9842C-0.43541 22.5146 4.50663 23.3285 7.22099 23.1698C7.1283 22.7563 7.07939 22.3262 7.07939 21.8847C7.07939 18.6538 9.69853 16.0347 12.9294 16.0347C16.1603 16.0347 18.7794 18.6538 18.7794 21.8847C18.7794 22.5053 18.6827 23.1034 18.5037 23.6646C18.6364 23.6728 18.7302 23.6794 18.7794 23.6843C19.3736 23.7437 40.2198 23.3667 50.8699 23.1651C50.7779 22.753 50.7294 22.3245 50.7294 21.8847C50.7294 18.6538 53.3485 16.0347 56.5794 16.0347C59.8103 16.0347 62.4294 18.6538 62.4294 21.8847C62.4294 22.0781 62.42 22.2693 62.4017 22.4579L63.1794 22.4093C64.6544 22.3093 67.6044 21.7943 67.6044 20.5343C67.6044 18.9593 67.3794 11.7593 67.0794 10.8593C66.7794 9.9593 62.5044 1.85924 61.0044 1.10924C59.5044 0.359243 31.0794 0.509243 28.6794 1.10924C26.7594 1.58924 18.6294 6.85924 14.8044 9.43424C10.3044 10.3592 1.10945 13.3642 0.329455 17.9842ZM20.6544 7.93469L18.1794 10.0347C19.0044 10.7847 20.4297 10.7847 20.8044 10.4097C21.1791 10.0347 21.0044 8.40969 20.6544 7.93469ZM34.9043 10.2597L25.1543 10.4847C24.9293 10.0097 24.1343 9.01469 22.7543 8.83469C22.2743 8.29469 22.5543 7.00969 22.7543 6.43469L30.1794 2.75969L34.9043 2.55183V10.2597ZM38.1294 2.55183V9.95969C38.1294 9.95969 46.525 9.95969 49.2294 9.35969C49.6 8.25183 49.0044 2.30969 49.0044 2.30969L38.1294 2.55183ZM52.3794 9.13471L52.0044 2.45971C54.4544 2.35971 59.5 2.37183 60.1 2.85183C60.85 3.45183 62.9544 6.20973 62.7294 7.40973C62.5494 8.36973 61.8044 8.95972 61.4544 9.13471H52.3794Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5797,
    cy: 21.8847,
    r: 3.675,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9293,
    cy: 21.8847,
    r: 3.675,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinivan);
export default ForwardRef;